import { __awaiter, __generator } from "tslib";
import { IconTooltip, Loader } from '@anex/common';
import * as valid from 'card-validator';
import { Form, withFormik } from 'formik';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import * as ReactTooltip from 'react-tooltip';
import { AlertContainer } from '../../../../components';
import { paymentMethods } from '../../../../stores/SaleStore';
import { CreditCard } from './components/CreditCard';
import { VoucherCode } from './components/VoucherCode';
import { PromotionCode } from './components/PromotionCode';
var PaymentForm = observer(function (props) {
    var wholesaleCustomerCode = props.config.wholesaleCustomerCode;
    var errors = props.errors, isSubmitting = props.isSubmitting, touched = props.touched, values = props.values;
    var ow30DayAccountValid = props.saleStore.ow30DayAccountValid;
    var previousStep = props.appStore.previousStep;
    return (React.createElement("div", { className: "secure-payment" },
        React.createElement(Loader, { loading: props.saleStore.loading, text: wholesaleCustomerCode === 'OT'
                ? 'Please wait we are loading...'
                : undefined }),
        React.createElement(Form, null,
            wholesaleCustomerCode === 'OT' ? (React.createElement(React.Fragment, null,
                React.createElement("label", { htmlFor: paymentMethods.creditCard, className: "checkbox p3" },
                    React.createElement("input", { id: paymentMethods.creditCard, type: "radio", name: "paymentMethod", className: "mr-1", checked: props.saleStore.paymentMethod === paymentMethods.creditCard, onChange: handlePaymentChange }),
                    React.createElement("small", { className: "label" }, "Credit or debit card")),
                props.saleStore.paymentMethod === paymentMethods.creditCard && (React.createElement(CreditCard, { errors: errors, touched: touched, wholesaleCustomerCode: wholesaleCustomerCode })),
                React.createElement("label", { htmlFor: paymentMethods.officeworks30DayAccountHolder, className: "checkbox p3" },
                    React.createElement("input", { id: paymentMethods.officeworks30DayAccountHolder, type: "radio", name: "paymentMethod", className: "mr-1", checked: props.saleStore.paymentMethod ===
                            paymentMethods.officeworks30DayAccountHolder, onChange: handlePaymentChange }),
                    React.createElement("small", { className: "label" },
                        "Officeworks 30 Day Business Account",
                        ' ',
                        React.createElement("a", { "data-tip": "true", "data-for": "labelTooltip" },
                            React.createElement(IconTooltip, null)),
                        React.createElement(ReactTooltip, { id: "labelTooltip", type: "dark", effect: "solid", place: "top" },
                            React.createElement("span", null, "You can use your Officeworks 30 Day Business Account to pay for your Accord plan")))),
                props.saleStore.paymentMethod ===
                    paymentMethods.officeworks30DayAccountHolder && (React.createElement(Officeworks30DayAccountHolder, null)))) : (React.createElement(CreditCard, { errors: errors, touched: touched, wholesaleCustomerCode: wholesaleCustomerCode })),
            React.createElement("div", { className: wholesaleCustomerCode === "OT" || 'EA' || 'PB' ? "p3" : "" },
                {
                    OT: React.createElement(VoucherCode, null),
                    EA: React.createElement(PromotionCode, null),
                    PB: React.createElement(PromotionCode, null),
                }[wholesaleCustomerCode],
                React.createElement("section", { className: "footer-buttons" },
                    React.createElement("button", { type: "button", className: "btn btn-shade btn-back", onClick: previousStep }, "Back"),
                    React.createElement("button", { type: "submit", className: "btn btn-submit", disabled: (props.saleStore.paymentMethod ===
                            paymentMethods.officeworks30DayAccountHolder &&
                            !ow30DayAccountValid) ||
                            isSubmitting }, "Submit"))))));
    function handlePaymentChange(e) {
        props.appStore.clearAlerts();
        props.saleStore.setPaymentMethod(paymentMethods[e.target.id]);
    }
});
var Officeworks30DayAccountHolder = inject('config', 'saleStore')(observer(function (props) {
    function officeWorksLogin() {
        var windowDefined = function () { return typeof 'window' !== 'undefined'; };
        if (windowDefined) {
            var popup = window.open(props.config.authEndPointUrl + "/anex-auth/login", 'newwindow', "width=600,height=400");
            props.saleStore.tokenizeOfficeWorksLogin(popup);
        }
    }
    var ow30DayAccountValid = props.saleStore.ow30DayAccountValid;
    return (React.createElement("div", { className: "p3 light" },
        React.createElement("div", { className: "pl-5" },
            React.createElement(AlertContainer, null),
            React.createElement("button", { type: "button", className: "btn btn-primary btn-ot-30-day-account-sign-in", disabled: ow30DayAccountValid, onClick: function () { return officeWorksLogin(); } }, "Sign in"),
            React.createElement("p", { className: "small mt-3" }, "Please ensure your browser has pop-ups enabled in order to sign into your 30 Day Business Account."))));
}));
export var Payment = inject('config', 'appStore', 'saleStore')(withFormik({
    handleSubmit: function (values, bag) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    bag.props.saleStore.setDetailsFromForm(values);
                    if (!(bag.props.saleStore.paymentMethod ===
                        paymentMethods.officeworks30DayAccountHolder)) return [3, 2];
                    return [4, bag.props.saleStore.createSale()];
                case 1:
                    _a.sent();
                    return [3, 4];
                case 2: return [4, bag.props.saleStore.submitCreditCardForm(values)];
                case 3:
                    _a.sent();
                    _a.label = 4;
                case 4:
                    bag.setSubmitting(false);
                    return [2];
            }
        });
    }); },
    mapPropsToValues: function (_a) {
        var saleStore = _a.saleStore;
        return saleStore.paymentDetails.formValues
            ? saleStore.paymentDetails.formValues
            : saleStore.paymentDetails.formInitialValues;
    },
    validate: function (values, props) {
        var errors = {};
        var isOfficeworksAccountHolder = props.saleStore.paymentMethod ===
            paymentMethods.officeworks30DayAccountHolder;
        var ow30DayAccountValid = props.saleStore.ow30DayAccountValid;
        var regExp = /^[^\s].*$/;
        var dateFormat = /^([0-1]{1}[0-9]{1})\/([1-9]{1}[0-9]{1})$/;
        if (!isOfficeworksAccountHolder) {
            if (!values['cardHolderName'] ||
                !regExp.test(values['cardHolderName'])) {
                errors.cardHolderName = "Please enter a valid card holder's name";
            }
            if (!valid.number(values['cardNumber']).isValid ||
                !/^[0-9]{16}$/.test(values['cardNumber'])) {
                errors.cardNumber = 'Please enter a valid card number';
            }
            if (!valid.expirationDate(values.ccExpirationDate).isValid ||
                !dateFormat.test(values.ccExpirationDate)) {
                errors.ccExpirationDate = 'Please enter a valid expiration date';
            }
            if (!valid.cvv(values['ccCvc']).isValid) {
                errors.ccCvc = 'Please enter a valid CVC';
            }
        }
        return errors;
    },
})(PaymentForm));
//# sourceMappingURL=Payment.js.map